import { render, staticRenderFns } from "./TherapySelectBackandForward.vue?vue&type=template&id=1126d57c"
import script from "./TherapySelectBackandForward.vue?vue&type=script&lang=js"
export * from "./TherapySelectBackandForward.vue?vue&type=script&lang=js"
import style0 from "./TherapySelectBackandForward.vue?vue&type=style&index=0&id=1126d57c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports